import React from 'react';

import { FormLabel, Stack, TextField } from '@mui/material';

interface Props {
  error?: boolean;
  helperText?: string;
  label: string;
  value: string;
  disabled?: boolean;
  onChange?: (value: string) => void;
}

export default function PackageTextField({ disabled, error, helperText, label, value, onChange }: Props) {
  return (
    <Stack spacing={1}>
      <FormLabel>{label}</FormLabel>
      <TextField
        value={value}
        size="small"
        fullWidth
        disabled={disabled}
        error={error}
        helperText={helperText}
        slotProps={{ formHelperText: { sx: { ml: 0 } } }}
        onChange={onChange ? (event) => onChange(event.target.value) : undefined}
      />
    </Stack>
  );
}
